"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("src/app/Services/service.service");
var router_1 = require("@angular/router");
var ValidateEmailComponent = /** @class */ (function () {
    function ValidateEmailComponent(route, service) {
        this.route = route;
        this.service = service;
    }
    ValidateEmailComponent.prototype.ngOnInit = function () {
        var _this = this;
        var code = this.route.snapshot.paramMap.get("code");
        if (code && code != "") {
            this.service.userService
                .validateEmail(code, "")
                .then(function (r) {
                _this.service.Over18Years = true;
                var userDataObject = btoa(JSON.stringify({ userId: r.userId.toString(), userPhone: r.userPhone }));
                _this.service.route.navigate(["/validate-phone/" + userDataObject]);
            })
                .catch(function (e) {
                _this.service.showError(e);
                _this.service.route.navigate(["/"]);
            });
        }
    };
    return ValidateEmailComponent;
}());
exports.ValidateEmailComponent = ValidateEmailComponent;
